import { normalizeEntryAnimationId } from "./escapeRoomEditorConstants";
import { getComicPageTransitionElementStyle } from "./escapeRoomComicPageTransition";
import { getScatterPageTransitionElementStyle } from "./escapeRoomScatterPageTransition";
import { getRevealPageTransitionElementStyle } from "./escapeRoomRevealPageTransition";
import {
	isStaggerEffectTransition,
	getStaggerEffectPageTransitionElementStyle,
} from "./escapeRoomStaggerEffectTransitions";

/**
 * Estilos CSS de animación de entrada al montar / cambiar de página.
 */
export function getElementEntryAnimationStyle(element, pageAnimKey, options = {}) {
	const {
		pageTransitionType,
		staggerIndex,
		staggerTotal,
		pageTransitionDurationMs,
	} = options;

	if (pageAnimKey && pageTransitionType && staggerIndex != null) {
		if (pageTransitionType === "comic") {
			return getComicPageTransitionElementStyle(
				staggerIndex,
				staggerTotal,
				pageTransitionDurationMs,
				element?.elementId
			);
		}
		if (pageTransitionType === "scatter") {
			return getScatterPageTransitionElementStyle(
				staggerIndex,
				staggerTotal,
				pageTransitionDurationMs,
				element
			);
		}
		if (pageTransitionType === "reveal") {
			return getRevealPageTransitionElementStyle(
				staggerIndex,
				staggerTotal,
				pageTransitionDurationMs,
				element
			);
		}
		if (isStaggerEffectTransition(pageTransitionType)) {
			return getStaggerEffectPageTransitionElementStyle(
				pageTransitionType,
				staggerIndex,
				staggerTotal,
				pageTransitionDurationMs,
				element
			);
		}
	}

	if (!pageAnimKey) return {};
	let anim = normalizeEntryAnimationId(element?.entryAnimation);
	if (anim === "typewriter") return {};
	const afterSec =
		element?.type === "button" && String(element?.content?.showWhen || "") === "afterSeconds";
	if (anim === "none" && afterSec) anim = "fade";
	if (anim === "none") return {};
	const ms = Number(element?.entryAnimationDuration);
	const durSec = (Number.isFinite(ms) && ms > 0 ? ms : 500) / 1000;
	return {
		animation: `er-entry-${anim} ${durSec}s ease-out forwards`,
	};
}
